const ApplicationModeWholesaler = 'wholesaler'
const ApplicationModeClipspec = 'clipspec'
const ValidApplicationModes = [ApplicationModeWholesaler, ApplicationModeClipspec]

export function isWholesalerMode() {
  if (process.env.REACT_APP_ENABLE_WHOLESALER_INTEGRATION === 'true') {
    return getApplicationMode() === ApplicationModeWholesaler
  }

  return false
}

export function isClipspecMode() {
  if (process.env.REACT_APP_ENABLE_CLIPSPEC_INTEGRATION === 'true') {
    return getApplicationMode() === ApplicationModeClipspec && window.parent !== null && window.parent !== window
  }

  return false
}

export function getApplicationMode(): string | null {
  const value = new URLSearchParams(window.location.search).get('mode')

  if (typeof value === 'string' && ValidApplicationModes.includes(value)) {
    return value
  }

  return null
}

export function getParentWindowHostname(): string | null {
  if (isWholesalerMode()) {
    const value = new URLSearchParams(window.location.search).get('parentHostname')

    if (typeof value === 'string' && value.length > 0) {
      return value
    }
  }

  return null
}